import { merge } from 'theme-ui'
import baseTheme from '@lekoarts/gatsby-theme-cara/src/gatsby-plugin-theme-ui/index'
import tailwind from "@theme-ui/preset-tailwind"

const customTheme = merge(baseTheme, {
  colors: {
    icon_brightest: tailwind.colors.white,
    modes: {
      light: {
        text: tailwind.colors.gray[8],
        heading: tailwind.colors.black,
        primary: tailwind.colors.orange[7],
        background: tailwind.colors.gray[1],
        divider: tailwind.colors.gray[2],
        textMuted: tailwind.colors.gray[6],
        icon_brightest: tailwind.colors.gray[2],
        icon_darker: tailwind.colors.gray[4],
        icon_darkest: tailwind.colors.gray[6],
      },
    },
  },
  breakpoints: [`600px`, `900px`, `1200px`, `1600px`],
  styles: {
    h1: {
      fontSize: ["1.5rem", "3rem", "3rem", "3rem"],
    }
  }

})

export default customTheme